import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { TypeFilter, ContractFilter } from "./useActivityData";
interface UseActivityFiltersReturn {
  // Filter states
  typeFilter: TypeFilter;
  selectedContract: ContractFilter;

  // Filter actions
  setTypeFilter: (filter: TypeFilter, resetPage?: () => void) => void;
  setSelectedContract: (contract: ContractFilter, resetPage?: () => void) => void;

  // Reset functionality
  resetFilters: () => void;
}
export function useActivityFilters() {
  const $ = _c(6);
  const [typeFilterState, setTypeFilterState] = useState(TypeFilter.ALL);
  const [selectedContractState, setSelectedContractState] = useState(ContractFilter.ALL);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (filter, resetPage) => {
      resetPage?.();
      setTypeFilterState(filter);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setTypeFilter = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (contract, resetPage_0) => {
      resetPage_0?.();
      setSelectedContractState(contract);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setSelectedContract = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setTypeFilterState(TypeFilter.ALL);
      setSelectedContractState(ContractFilter.ALL);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const resetFilters = t2;
  let t3;
  if ($[3] !== selectedContractState || $[4] !== typeFilterState) {
    t3 = {
      typeFilter: typeFilterState,
      selectedContract: selectedContractState,
      setTypeFilter,
      setSelectedContract,
      resetFilters
    };
    $[3] = selectedContractState;
    $[4] = typeFilterState;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}